import i18n from "i18next"
import en from "./translations/en.json"
import de from "./translations/de.json"

i18n.init({
  fallbackLng: "de",
  interpolation: {
    prefix: "{",
    suffix: "}",
    escapeValue: false,
  },
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  react: {
    wait: true,
  },
})

const t = (...args) => i18n.t(...args)

export { i18n, t }
